import { render, staticRenderFns } from "./EncuestasFormularios.vue?vue&type=template&id=24a6ba22"
import script from "./EncuestasFormularios.vue?vue&type=script&lang=js"
export * from "./EncuestasFormularios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports